/* ==========================================================================
   VETMA — Page produit
   Met à jour l'état (pre-order / in stock / sold out), le prix et le bouton
   au changement de variante, sans rechargement de page.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-vetma-product]');
  if (!root) return;

  /* --- Données injectées par Liquid --- */
  var states = {};
  (root.dataset.variantStates || '').split(',').forEach(function (pair) {
    if (!pair) return;
    var parts = pair.split(':');
    if (parts.length === 2) states[parts[0]] = parts[1];
  });

  var quantities = {};
  (root.dataset.variantQty || '').split(',').forEach(function (pair) {
    if (!pair) return;
    var parts = pair.split(':');
    if (parts.length === 2) quantities[parts[0]] = parseInt(parts[1], 10);
  });

  var variants = window.vetmaVariants || [];
  var currentQty = null;

  var els = {
    status: root.querySelector('[data-status]'),
    statusText: root.querySelector('[data-status-text]'),
    atc: root.querySelector('[data-atc]'),
    atcText: root.querySelector('[data-atc-text]'),
    input: root.querySelector('[data-variant-input]'),
    express: root.querySelector('[data-express]'),
    shipEst: root.querySelector('[data-ship-est]'),
    trustSets: root.querySelectorAll('[data-trust-set]'),
    prices: root.querySelectorAll('[data-price]'),
    sticky: root.querySelector('[data-sticky]'),
    stickyStatus: root.querySelector('[data-sticky-status]'),
    stickyStatusText: root.querySelector('[data-sticky-status-text]'),
    stickyBtn: root.querySelector('[data-sticky-btn]'),
    stickyBtnText: root.querySelector('[data-sticky-btn-text]'),
    form: root.querySelector('form[action*="/cart/add"]')
  };

  var labels = root.dataset;

  /* ----------------------------------------------------------------------
     Carrousel d'images
     Défilement tactile sur mobile, flèches sur desktop, miniatures partout.
     ---------------------------------------------------------------------- */
  var track = root.querySelector('[data-track]');

  if (track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.v-pdp__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.v-dots__dot'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.v-pdp__thumb'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var current = 0;

    function goTo(index) {
      if (index < 0 || index >= slides.length) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    /* Suit la position réelle du défilement, tactile comme flèches */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current) setActive(Math.min(index, slides.length - 1));
      }, 90);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); setActive(i); });
    });

    /* Flèches du clavier quand le carrousel a le focus */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    setActive(0);
  }

  /* ----------------------------------------------------------------------
     Sélection de variante
     ---------------------------------------------------------------------- */
  function selectedOptions() {
    var opts = [];
    root.querySelectorAll('.v-pdp__option').forEach(function (group) {
      var active = group.querySelector('.v-pdp__value.is-active');
      opts[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (variant) {
      return opts.every(function (val, i) {
        return val === null || variant.options[i] === val;
      });
    });
  }

  function applyState(state) {
    if (!els.status) return;

    els.status.className = 'v-status v-status--' + state;
    root.dataset.state = state;

    var text = labels['label' + state.charAt(0).toUpperCase() + state.slice(1)];
    if (text && currentQty !== null) text = text.replace('[qty]', currentQty);
    if (els.statusText && text) els.statusText.textContent = text;

    if (els.atc) {
      els.atc.disabled = state === 'soldout';
      var btn = labels['btn' + state.charAt(0).toUpperCase() + state.slice(1)];
      if (els.atcText && btn) els.atcText.textContent = btn;
    }

    if (els.express) els.express.hidden = state === 'soldout';

    /* La date d'expédition n'a de sens qu'en précommande */
    if (els.shipEst) els.shipEst.hidden = state !== 'preorder';

    /* Le jeu de réassurance suit l'état du produit */
    els.trustSets.forEach(function (set) {
      var wanted = state === 'preorder' ? 'preorder' : 'stock';
      set.hidden = set.dataset.trustSet !== wanted;
    });

    /* La barre flottante reflète le même état */
    if (els.stickyStatus) {
      els.stickyStatus.className = 'v-status v-status--' + state + ' v-status--inline';
      var stickyLabel = labels['label' + state.charAt(0).toUpperCase() + state.slice(1)];
      if (stickyLabel && currentQty !== null) stickyLabel = stickyLabel.replace('[qty]', currentQty);
      if (els.stickyStatusText && stickyLabel) els.stickyStatusText.textContent = stickyLabel;
    }
    if (els.stickyBtn) {
      els.stickyBtn.disabled = state === 'soldout';
      var stickyBtnLabel = labels['btn' + state.charAt(0).toUpperCase() + state.slice(1)];
      if (els.stickyBtnText && stickyBtnLabel) els.stickyBtnText.textContent = stickyBtnLabel;
    }
  }

  function updateVariant() {
    var variant = findVariant(selectedOptions());
    if (!variant) {
      applyState('soldout');
      return;
    }

    if (els.input) els.input.value = variant.id;
    els.prices.forEach(function (el) { el.textContent = variant.price; });
    currentQty = quantities[variant.id];
    if (currentQty === undefined) currentQty = null;

    applyState(states[variant.id] || 'instock');

    /* Met l'URL à jour sans recharger — utile pour le partage de lien */
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  root.querySelectorAll('.v-pdp__value').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.v-pdp__option');
      group.querySelectorAll('.v-pdp__value').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      updateVariant();
    });
  });

  /* ----------------------------------------------------------------------
     Onglets
     ---------------------------------------------------------------------- */
  var tabs = root.querySelector('[data-tabs]');
  if (tabs) {
    tabs.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;

        tabs.querySelectorAll('[data-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        tabs.querySelectorAll('[data-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.panel === target);
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Ajout au panier avec le cadeau offert
     Le cadeau part avec le produit ; la reduction Shopify le met a 0 EUR.
     ---------------------------------------------------------------------- */
  var giftId = root.dataset.giftVariant;
  var giftForm = els.form || document.querySelector('form[action*="/cart/add"]');

  if (giftId && giftForm) {
    var CART_SECTIONS = 'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';

    giftForm.addEventListener('submit', function (e) {
      var input = giftForm.querySelector('input[name="id"]');
      var current = input ? String(input.value) : null;
      if (!current) return;

      e.preventDefault();
      if (els.atc) els.atc.disabled = true;

      /* La reduction Shopify n'offre qu'un cadeau par commande :
         on ne l'ajoute que s'il n'y est pas deja. */
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = [{ id: current, quantity: 1 }];
          var alreadyGifted = cart.items.some(function (line) {
            return line.properties && line.properties._gift;
          });

          if (!alreadyGifted) {
            items.push({
              id: giftId,
              quantity: 1,
              properties: { _gift: root.dataset.giftLabel || 'Free gift' }
            });
          }

          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: CART_SECTIONS })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          window.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              detail: { response: response }
            })
          );

          setTimeout(function () {
            if (window.Alpine && Alpine.store && Alpine.store('modals')) {
              Alpine.store('modals').open('cart');
            }
            if (els.atc) els.atc.disabled = false;
          }, 300);
        })
        .catch(function () {
          if (els.atc) els.atc.disabled = false;
          giftForm.submit();
        });
    });
  }

  /* ----------------------------------------------------------------------
     Choix : produit seul ou pack
     Change l'article ajoute au panier, le prix affiche et le bouton.
     ---------------------------------------------------------------------- */
  var choice = root.querySelector('[data-choice]');
  if (choice) {
    var radios = choice.querySelectorAll('input[type="radio"]');

    function applyChoice(radio) {
      if (els.input) els.input.value = radio.value;

      /* Seul le prix des boutons suit le choix : le prix affiché en haut
         reste celui du produit dont c'est la page. */
      root.querySelectorAll('[data-choice-price-target]').forEach(function (el) {
        el.textContent = radio.dataset.choicePrice;
      });

      var label = radio.dataset.choiceLabel;
      if (label) {
        if (els.atcText) els.atcText.textContent = label;
        if (els.stickyBtnText) els.stickyBtnText.textContent = label;
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applyChoice(radio);
      });
    });

    /* Applique l'option pre-cochee au chargement */
    var checked = choice.querySelector('input:checked');
    if (checked) applyChoice(checked);
  }

  /* ----------------------------------------------------------------------
     Pop-up : suivi de production
     ---------------------------------------------------------------------- */
  var modal = root.querySelector('[data-tracker]');
  if (modal) {
    var lastFocus = null;

    function openTracker() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      /* Laisse le navigateur peindre avant d'animer */
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-tracker-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeTracker() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 300);
      if (lastFocus) lastFocus.focus();
    }

    root.querySelectorAll('[data-open-tracker]').forEach(function (trigger) {
      trigger.addEventListener('click', openTracker);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openTracker(); }
      });
    });

    modal.querySelectorAll('[data-tracker-close]').forEach(function (btn) {
      btn.addEventListener('click', closeTracker);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeTracker();
    });
  }

  /* ----------------------------------------------------------------------
     Barre d'achat flottante
     Apparaît dès que le bouton principal sort de l'écran.
     ---------------------------------------------------------------------- */
  if (els.sticky && els.atc) {
    els.sticky.hidden = false;
    els.sticky.setAttribute('aria-hidden', 'true');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var visible = entries[0].isIntersecting;
          els.sticky.classList.toggle('is-visible', !visible);
          els.sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
        },
        { rootMargin: '0px 0px -80px 0px' }
      ).observe(els.atc);
    }

    /* Le bouton flottant déclenche le vrai formulaire */
    if (els.stickyBtn && els.form) {
      els.stickyBtn.addEventListener('click', function () {
        if (els.stickyBtn.disabled) return;
        if (typeof els.form.requestSubmit === 'function') {
          els.form.requestSubmit(els.atc);
        } else {
          els.atc.click();
        }
      });
    }
  }
})();
